export default "/images/indeco_bank.png?73a32e95a4076b3c67f31ed4b0207fe2";